/*!

=========================================================
* Paper Kit React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import {Link, useLocation} from "react-router-dom";
// nodejs library that concatenates strings
import classnames from "classnames";

// reactstrap components
import {
    Collapse,
    NavbarBrand,
    Navbar,
    NavItem,
    NavLink,
    Nav,
    Container,
    Button,
} from "reactstrap";

function ExamplesNavbar() {
    const location = useLocation();

    const [navbarColor, setNavbarColor] = React.useState(location.pathname === "/" && "navbar-transparent");
    const [navbarCollapse, setNavbarCollapse] = React.useState(false);
    const screenWidth = window.innerWidth;

    const toggleNavbarCollapse = () => {
        setNavbarCollapse(!navbarCollapse);
        document.documentElement.classList.toggle("nav-open");
    };

    React.useEffect(() => {
        const updateNavbarColor = () => {
            if (
                document.documentElement.scrollTop > 299 ||
                document.body.scrollTop > 299
            ) {
                setNavbarColor("");
            } else if (
                document.documentElement.scrollTop < 300 ||
                document.body.scrollTop < 300
            ) {
                if(location.pathname === "/"){
                    setNavbarColor("navbar-transparent");
                }
            }
        };

        window.addEventListener("scroll", updateNavbarColor);

        return function cleanup() {
            window.removeEventListener("scroll", updateNavbarColor);
        };
    });
    return (
        <div>
            <Navbar
                className={classnames("fixed-top", navbarColor)}
                color-on-scroll="3000"
                expand="lg"
            >
                <Container style={{alignItems: "center", display: "flex", justifyContent: "space-between"}}>
                    <div className="navbar-translate">
                        <NavbarBrand
                            data-placement="bottom"
                            to="/"
                            title="Ozsolar Enerji"
                            tag={Link}
                        >
                            <img
                                alt="Ozsolar Enerji"
                                src={require("../../assets/images/ozs-logo.png")}
                                className="img-fluid"
                                style={{
                                    height: 'auto',
                                    width: '100%',
                                    maxWidth: screenWidth < 500 ? 100 : 160,
                                    maxHeight: screenWidth < 500 ? 100 : 160,
                                    objectFit: 'contain'
                                }}
                            />
                        </NavbarBrand>
                        <button
                            aria-expanded={navbarCollapse}
                            className={classnames("navbar-toggler navbar-toggler", {
                                toggled: navbarCollapse,
                            })}
                            onClick={toggleNavbarCollapse}
                        >
                            <span className="navbar-toggler-bar bar1"/>
                            <span className="navbar-toggler-bar bar2"/>
                            <span className="navbar-toggler-bar bar3"/>
                        </button>
                    </div>
                    <Collapse
                        className="justify-content-end"
                        navbar
                        isOpen={navbarCollapse}
                    >
                        {screenWidth > 1024 ? <div className="nav-custom-links">
                                <nav
                                    className={classnames('navMenu', {'transparent': navbarColor === "navbar-transparent"})}>
                                    <a href="/products">Ürünler</a>
                                    <a href="/projects">Referanslarımız</a>
                                    <a href="/contact">İletişim</a>
                                    <div className="dot"></div>
                                </nav>
                            </div> :
                            <Nav navbar>
                                <NavItem>
                                    <NavLink to="/products" tag={Link}>
                                        Ürünler
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href="/projects"
                                    >
                                        Referanslarımız
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href="/contact"
                                    >
                                        İletişim
                                    </NavLink>
                                </NavItem>
                            </Nav>}
                    </Collapse>
                </Container>
            </Navbar>
        </div>
    )
        ;
}

export default ExamplesNavbar;
